export const enum CacheKeys {
  BOOKKEEPER_CUSTOMERS = 'BOOKKEEPER_CUSTOMERS',
  APPLICATION = 'APPLICATION',
  FAILURE_ANALYSIS = 'FAILURE_ANALYSIS',
  AUTH = 'AUTH',
  CURRENT_USER = 'CURRENT_USER',
  CLAIMS = 'CLAIMS',
  INTERNAL_CLAIMS = 'INTERNAL_CLAIMS',
  DRIVERS = 'DRIVERS',
  MVR_ELIGIBILITY = 'MVR_ELIGIBILITY',
  TRUCKS = 'TRUCKS',
  TRAILERS = 'TRAILERS',
  WEIGHT_CLASSES_CONFIG = 'WEIGHT_CLASSES_CONFIG',
  ORGANISATIONS = 'ORGANISATIONS',
  ORG_DOCUMENTS = 'ORG_DOCUMENTS',
  ORG_DOCUMENT_GROUPS = 'ORG_DOCUMENT_GROUPS',
  ORG_DOCUMENTS_BY_TYPE = 'ORG_DOCUMENTS_BY_TYPE',
  VAULT_TREE = 'VAULT_TREE',
  VAULT_FOLDER = 'VAULT_FOLDER',
  VAULT_FILE = 'VAULT_FILE',
  VAULT_RECEIPT = 'VAULT_RECEIPT',
  VAULT_UPLOAD = 'VAULT_UPLOAD',
  VAULT_DOCUMENT_PARSE = 'VAULT_DOCUMENT_PARSE',
  VAULT_SCOPE = 'VAULT_SCOPE',
  VAULT_TIMELINE = 'VAULT_TIMELINE',
  ORG_ENVELOPES = 'ORG_ENVELOPES',
  DASHBOARD_EVENTS = 'DASHBOARD_EVENTS',
  DASHBOARD_RISK = 'DASHBOARD_RISK',
  DASHBOARD_ACCIDENTS = 'DASHBOARD_ACCIDENTS',
  DASHBOARD_DRIVERS_RISK = 'DASHBOARD_DRIVERS_RISK',
  DASHBOARD_SAFETY_SNAPSHOT = 'DASHBOARD_SAFETY_SNAPSHOT',
  DASHBOARD_CLAIMS_HISTORY = 'DASHBOARD_CLAIMS_HISTORY',
  EMAIL_TEMPLATES = 'EMAIL_TEMPLATES',
  SEQUENCES = 'SEQUENCES',
  SEQUENCE_TEMPLATES = 'SEQUENCE_TEMPLATES',
  LOSS_RUN_REQUESTS = 'LOSS_RUN_REQUESTS',
  INTERNAL_APPLICATIONS = 'INTERNAL_APPLICATIONS',
  COI_DOCUMENT_LATEST = 'COI_DOCUMENT_LATEST',
  COI_DOCUMENTS_CURRENT = 'COI_DOCUMENTS_CURRENT',
  COI_CERTIFICATE_HOLDERS = 'COI_CERTIFICATE_HOLDERS',
  COI_CERTIFICATE_HOLDER = 'COI_CERTIFICATE_HOLDER',
  COI_SENDABLE_HOLDERS = 'COI_SENDABLE_HOLDERS',
  COI_BULK_MOVE_PREVIEW = 'COI_BULK_MOVE_PREVIEW',
  COI_EMAIL_THREADS = 'COI_EMAIL_THREADS',
  COI_EMAIL_THREAD = 'COI_EMAIL_THREAD',
  COI_SENT_LOGS = 'COI_SENT_LOGS',
  COI_GENERATOR = 'COI_GENERATOR',
  COI_REQUESTS = 'COI_REQUESTS',
  AGENT_VERSIONS = 'AGENT_VERSIONS',
  AGENT_MCP_AUDIT_LOG = 'AGENT_MCP_AUDIT_LOG',
  AGENT_CHAT_HISTORY = 'AGENT_CHAT_HISTORY',
  STAFF_USERS = 'STAFF_USERS',
  STAFF_USER = 'STAFF_USER',
  STAFF_USER_ACTIVITY = 'STAFF_USER_ACTIVITY',
  STAFF_USER_REMINDERS = 'STAFF_USER_REMINDERS',
  USER_ORGANISATIONS = 'USER_ORGANISATIONS',
  KNOWLEDGE_DOCUMENTS = 'KNOWLEDGE_DOCUMENTS',
  KNOWLEDGE_FOLDERS = 'KNOWLEDGE_FOLDERS',
  KNOWLEDGE_DOCUMENT_VERSIONS = 'KNOWLEDGE_DOCUMENT_VERSIONS',
  BOR_SIGN_URL = 'BOR_SIGN_URL',
  ENVELOPE_SIGN_URL = 'ENVELOPE_SIGN_URL',
  FUNNEL_SESSION = 'FUNNEL_SESSION',
  CAB_LOOKUP = 'CAB_LOOKUP',
  CAB_LEAD = 'CAB_LEAD',
  CAB_VEHICLES = 'CAB_VEHICLES',
  CAB_CRASHES = 'CAB_CRASHES',
  CAB_SEVERE_VIOLATIONS = 'CAB_SEVERE_VIOLATIONS',
  VIN_LOOKUP = 'VIN_LOOKUP',
  SALES_LEADS = 'SALES_LEADS',
  SALES_LEAD_TAGS = 'SALES_LEAD_TAGS',
  CARRIERS = 'CARRIERS',
  CORGI_PORTAL_SESSION = 'CORGI_PORTAL_SESSION',
  NAIC_COMPANIES = 'NAIC_COMPANIES',
  LEAD_DOCUMENTS = 'LEAD_DOCUMENTS',
  AUTO_LIABILITY_ESTIMATE = 'AUTO_LIABILITY_ESTIMATE',
  AIRCALL_CALLS = 'AIRCALL_CALLS',
  AIRCALL_SMS = 'AIRCALL_SMS',
  TELEPHONY_SMS = 'TELEPHONY_SMS',
  TELEPHONY_CALLS = 'TELEPHONY_CALLS',
  AGENT_CONVERSATIONS = 'AGENT_CONVERSATIONS',
  AGENT_CONVERSATION = 'AGENT_CONVERSATION',
  AGENT_PAGE_CONTEXT = 'AGENT_PAGE_CONTEXT',
  PENDING_EQUIPMENT_CHANGES = 'PENDING_EQUIPMENT_CHANGES',
  POLICY_CHANGES = 'POLICY_CHANGES',
  INTERNAL_ENDORSEMENTS = 'INTERNAL_ENDORSEMENTS',
  REQUOTE_REQUESTS = 'REQUOTE_REQUESTS',
  MY_REMINDERS = 'MY_REMINDERS',
  WORK_QUEUE = 'WORK_QUEUE',
  MY_PIPELINE = 'MY_PIPELINE',
  TASK_STATUS = 'TASK_STATUS',
  EMAIL_REPORT = 'EMAIL_REPORT',
  AGENT_RUN_REPORT = 'AGENT_RUN_REPORT',
  EMAIL_THREADS = 'EMAIL_THREADS',
  EMAIL_THREAD = 'EMAIL_THREAD',
  EMAIL_SENDERS = 'EMAIL_SENDERS',
  QA_EMAIL_INBOXES = 'QA_EMAIL_INBOXES',
  QA_EMAIL_THREADS = 'QA_EMAIL_THREADS',
  QA_EMAIL_THREAD = 'QA_EMAIL_THREAD',
  GLOBAL_SEARCH = 'GLOBAL_SEARCH',
  PUBLIC_CLAIM = 'public-claim',
  INSURANCE_VENDORS = 'INSURANCE_VENDORS',
  QUOTE_ANALYTICS = 'QUOTE_ANALYTICS',
  SALES_ANALYTICS = 'SALES_ANALYTICS',
  ORG_BROKER = 'ORG_BROKER',
  CARRIER_ATTESTATIONS = 'CARRIER_ATTESTATIONS',
  POLICY_DOCUMENT_REVIEW = 'POLICY_DOCUMENT_REVIEW',
  POST_BIND_CHECKLIST = 'POST_BIND_CHECKLIST',
  FILL_APPLICATION_STATE = 'FILL_APPLICATION_STATE',
  FREIGHT_SUGGESTIONS = 'FREIGHT_SUGGESTIONS',
  ORG_FREIGHT_SUGGESTIONS = 'ORG_FREIGHT_SUGGESTIONS',
  DRIVER_LICENSE_CHECK = 'DRIVER_LICENSE_CHECK',
  DOCUMENT_TABLE = 'DOCUMENT_TABLE',
}

/**
 * Refresh whatever carries the application summary after a roster write.
 *
 * The confirm step's card validation rides on the org payload, not on the
 * driver/truck/trailer queries, so invalidating only those leaves the banner
 * arguing with the table it sits under. `CURRENT_USER` is the one that matters
 * in the customer's own flow, where there is no `orgId` to key on.
 */
export function invalidateApplicationSummary(
  queryClient: { invalidateQueries: (filters: { queryKey: unknown[] }) => unknown },
  orgId?: string
): void {
  queryClient.invalidateQueries({ queryKey: [CacheKeys.CURRENT_USER] })
  queryClient.invalidateQueries({ queryKey: [CacheKeys.ORGANISATIONS, orgId] })
}
